import GetterTypes from '@/store/constants/getters';
import themes from '@/themes/themes';

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        selectedTheme() {
          return themes[this.$store.getters[GetterTypes.THEME]];
        },
        availableThemes() {
          return themes;
        },
      },
    });
  },
};
